import { Component, OnInit } from '@angular/core';
import { AdminServicesService } from '../admin-services.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { UserService } from 'src/app/user.service';

@Component({
  selector: 'app-dashboard-admin',
  templateUrl: './dashboard-admin.component.html',
  styleUrls: ['./dashboard-admin.component.css']
})
export class DashboardAdminComponent implements OnInit {
  createdBy: any;

  constructor(public admin: AdminServicesService,
    public router: Router,
    public toastr: ToastrService,
    public userService: UserService) {
       // this.userDtls = JSON.parse(localStorage.getItem('userDetails'));
    if (!localStorage.getItem('userDetails')) {
      // alert("User Already Loged out , Please Login Again");
      this.router.navigate(["login-admin"]);
    } else {
      this.createdBy = JSON.parse(localStorage.getItem('userDetails'));
    }
    // this.createdBy = JSON.parse(localStorage.getItem('userDetails'));
  }

  ngOnInit(): void {
  }

  logout() {
    this.admin.logout().subscribe((res: any) => {
      if (res.code === 200) {
        console.log(res);
        this.userService.loggedIn = false;
        this.toastr.success(res.message);
        localStorage.clear();
        setTimeout(() => {
          this.router.navigate(['login-admin']);
        }, 300);
      } else {
        this.router.navigate(['login-admin']);
        this.toastr.error(res.message)
      }
    }, (err) => {
      this.router.navigate(['login-admin']);
      this.toastr.error(err);
    })
  }
}
